import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import ConfirmDialog from '../../helpers/ConfirmDialog';

export const DeleteQuoteForm = ({ quote, setQuotes }) => {
    const { token, base_url } = useAppContext();

    return (
        <ConfirmDialog
            trigger={
                <button className="btn btn-action btn-danger" title="Delete Quote">
                    <FontAwesomeIcon icon={faTrash} /> Archive Quote
                </button>
            }
            title="Archive Quote"
            message="Are you sure you want to archive this quote?"
            entityLabel={`Quote: ${quote?.quote_number}`}
            detail="This action will archive the quote and remove it from your active quotes list."
            confirmLabel="Archive Quote"
            submittingLabel="Archiving..."
            successMessage="Quote archived successfully!"
            errorMessages={{
                notFound: 'Quote not found',
                client: 'Invalid quote data. Please check your input.',
                default: 'Failed to archive quote. Please try again.',
            }}
            onConfirm={async () => {
                const updated_quote = await updateData(
                    token,
                    `${base_url}/apis/billing/${quote.id}`,
                    { is_archived: true }
                );

                if (!updated_quote.quote) return false;

                setQuotes((prevQuotes) =>
                    prevQuotes.filter((q) => q.id !== quote.id)
                );
            }}
        />
    );
};
